import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { NavigateBackDirective } from './directives/navigate-back/navigate-back.directive';
import { RedirectFarefinderDirective } from './directives/redirect-farefinder/redirect-farefinder.directive';
import { PipesModule } from './pipes/pipes.module';

import { AccordionModule } from 'ngx-bootstrap/accordion';
import { InnerLoaderComponent } from './components/inner-loader/inner-loader.component';
import { NavigateNextDirective } from './directives/navigate-next.directive.ts/navigate-next.directive';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { OrderSendDocsModalComponent } from './components/order-send-docs-modal/order-send-docs-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RichTextDirective } from './directives/rich-text/rich-text.directive';

@NgModule({
  imports: [
    CommonModule,
    ModalModule,
    TranslateModule,
    TypeaheadModule,
    PipesModule,
    ReactiveFormsModule,
    AccordionModule.forRoot(),
    BsDatepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    PaginationModule.forRoot(),
    PopoverModule.forRoot(),
  ],
  declarations: [
    RedirectFarefinderDirective,
    NavigateBackDirective,
    InnerLoaderComponent,
    NavigateNextDirective,
    OrderSendDocsModalComponent,
    RichTextDirective,
  ],
  exports: [
    AccordionModule,
    CommonModule,
    ModalModule,
    TranslateModule,
    TypeaheadModule,
    PipesModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    RedirectFarefinderDirective,
    NavigateBackDirective,
    RichTextDirective,
    BsDropdownModule,
    PaginationModule,
    InnerLoaderComponent,
    OrderSendDocsModalComponent,
  ],
})
export class SharedModule {}
